import { render, staticRenderFns } from "./sortLabel.vue?vue&type=template&id=0d2d3ed8&scoped=true"
import script from "./sortLabel.vue?vue&type=script&lang=js"
export * from "./sortLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d3ed8",
  null
  
)

export default component.exports